import { Action, createReducer, on } from '@ngrx/store';
import { fromProductAnnualSwitchLimitsAction } from '../actions';
import { ErrorResponse, IGenericError } from '../../../../src/app/core/models/generic-models';
import { IStaticDataNumberResponse, IStaticDataResponse } from '../models/static-data.model';

export const productAnnualSwitchLimitsFeatureKey = 'productAnnualSwitchLimits';

export interface ProductAnnualSwitchLimitsState {
  productAnnualSwitchLimitsResponse: IStaticDataNumberResponse[];
  productAnnualSwitchLimitsFailure: IGenericError<ErrorResponse>;
  loaded: boolean;
}

export const initialState: ProductAnnualSwitchLimitsState = {
  productAnnualSwitchLimitsFailure: undefined,
  productAnnualSwitchLimitsResponse: undefined,
  loaded: undefined
};

export const reducer = createReducer(
  initialState,

  on(fromProductAnnualSwitchLimitsAction.loadProductAnnualSwitchLimits, (state, action) => ({
    ...state,
    loaded: true
  })),

  on(fromProductAnnualSwitchLimitsAction.loadProductAnnualSwitchLimitsSuccess, (state, action) => ({
    ...state,
    productAnnualSwitchLimitsResponse: action.response
  })),

  on(fromProductAnnualSwitchLimitsAction.loadProductAnnualSwitchLimitsFailure, (state, action) => ({
    ...state,
    productAnnualSwitchLimitsFailure: action.error
  }))
);

export const getProductAnnualSwitchLimitsResponse = (state: ProductAnnualSwitchLimitsState) => state.productAnnualSwitchLimitsResponse;
export const getProductAnnualSwitchLimitsFailure = (state: ProductAnnualSwitchLimitsState) => state.productAnnualSwitchLimitsFailure;
export const getProductAnnualSwitchLimitsIsLoaded = (state: ProductAnnualSwitchLimitsState) => state.loaded;
